import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';

import { getBogoIndividualDiscount } from 'shared/order/utilities';

const getBogoDiscountForAddedItems = (
  costBreakdownDetails,
  individualPrice,
  product,
  option,
  quantity,
  specialsSettings
) => {
  const breakdownItem = _.find(costBreakdownDetails || [], { id: product.id || product._id, option });
  const { discountTotal: bogoDiscount } = _.reduce(
    breakdownItem?.bogoSavings?.individual || [],
    ({ discountTotal, itemPrice }, savingsObj) => {
      // we don't want to show the discount badge if it's
      // a discount to cart reward
      if (savingsObj.isDiscountToCartReward) {
        return { discountTotal, itemPrice };
      }
      const previousItemsAddedPastCondition = Math.max(
        0,
        breakdownItem.quantity - quantity - savingsObj.conditionQuantity
      );
      const totalItemsAddedPastCondition = Math.max(0, breakdownItem.quantity - savingsObj.conditionQuantity);
      const availableDiscounts = Math.max(0, savingsObj.maxApplicable - previousItemsAddedPastCondition);
      const discountQuantity = Math.min(availableDiscounts, totalItemsAddedPastCondition);
      const discountAmount = getBogoIndividualDiscount(savingsObj, itemPrice).times(discountQuantity);
      return {
        discountTotal: discountTotal.add(discountAmount),
        itemPrice:
          specialsSettings?.discountBehavior === 'compounding'
            ? itemPrice.minus(discountAmount.div(breakdownItem.quantity))
            : itemPrice,
      };
    },
    { discountTotal: Big(0), itemPrice: Big(individualPrice || 0) }
  );
  return !_.isNil(bogoDiscount) && bogoDiscount.gt(0) ? bogoDiscount : null;
};

export default getBogoDiscountForAddedItems;
